import type { User } from '@auth0/auth0-react';

// TODO: Use name from DynamoDB instead of Auth0

export const createInitials = (user?: User): string | undefined =>
  user?.given_name &&
  user?.family_name &&
  `${user?.given_name[0]}${user?.family_name[0]}`.toUpperCase();
